import React from 'react';
import { PageTransition } from '../components/PageTransition';
export function PrivacyPolicyPage() {
  return <PageTransition data-id="element-692" data-mp="31q9z2x4ujqqm">
      <div className="pt-32 pb-24 min-h-screen bg-dark-700" data-id="element-693" data-mp="31qt7nn8lx2rz">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-694" data-mp="2mukacr8a0zi7">
          <div className="mb-12" data-id="element-695" data-mp="2mweu427talkp">
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-696" data-mp="2rsccee2my204">
              Privacy Policy
            </h1>
            <div className="w-24 h-1 bg-gold-500 rounded-full mb-6" data-id="element-697" data-mp="2e05xswf4s32s"></div>
            <p className="text-white/60" data-id="element-698" data-mp="2ispcxxtgv69p">Last updated: March 2026</p>
          </div>

          <div className="prose prose-invert prose-gold max-w-none space-y-8 text-white/80" data-id="element-699" data-mp="2442uhn8jlye9">
            <section data-id="element-700" data-mp="2924dy99vrzq9">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-701" data-mp="293p7bvkglcmj">
                1. Our Commitment to Your Privacy
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-702" data-mp="1v58qhbsvu5qo">
                At 3 Doves Podcast, we deeply value the trust you place in us.
                Whether you are a listener, a guest, a donor, or a volunteer,
                your privacy is of the utmost importance to our ministry.
              </p>
              <div className="bg-dark-600 border-l-4 border-gold-500 p-6 rounded-r-lg my-6" data-id="element-703" data-mp="24uwd6tfs8qhr">
                <p className="text-white font-medium text-lg m-0" data-id="element-704" data-mp="2jnq378sokp0o">
                  We do not sell anyone's information. Any emails or calls are
                  not sold. All volunteer information is strictly confidential
                  and is not sold to any third parties.
                </p>
              </div>
            </section>

            <section data-id="element-705" data-mp="20r6rqcuemp0y">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-706" data-mp="20rq99sg57beg">
                2. Information We Collect
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-707" data-mp="1vydndq2ulipe">
                We only collect information that you voluntarily provide to us,
                which may include:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-708" data-mp="13baubdgxy06j">
                <li data-id="element-709" data-mp="1syn8xqmsxla3">
                  Name and contact information (such as email address and phone
                  number) when you reach out to us, subscribe to updates, or
                  volunteer.
                </li>
                <li data-id="element-710" data-mp="21ss6eswfxuyl">
                  Donation information when you choose to financially support
                  our mission.
                </li>
                <li data-id="element-711" data-mp="1a1c9a4x9cpu4">Communication records when you call or email our team.</li>
              </ul>
            </section>

            <section data-id="element-712" data-mp="1e3h251fvtifp">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-713" data-mp="1e2xse80dy0cr">
                3. How We Use Your Information
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-714" data-mp="1o0bypeslh8rc">
                The information we collect is used solely for the purpose of
                fulfilling our mission and serving you better. This includes:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-715" data-mp="2zez91x96pd8b">
                <li data-id="element-716" data-mp="2zhldvp4oxemu">
                  Sending you podcast updates, newsletters, and ministry
                  announcements (only if you have opted in).
                </li>
                <li data-id="element-717" data-mp="iu3yvsjzoycu">Coordinating volunteer efforts and outreach programs.</li>
                <li data-id="element-718" data-mp="e1auj5sfns1a">Processing donations and providing tax receipts.</li>
                <li data-id="element-719" data-mp="9428uv82t5va">
                  Responding to your inquiries, prayer requests, or feedback.
                </li>
              </ul>
            </section>

            <section data-id="element-720" data-mp="4zun96wx061a">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-721" data-mp="3460g9dj4ea">
                4. Data Security
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-722" data-mp="3ra6x77p7paoi">
                We implement appropriate technical and organizational security
                measures to protect your personal information against
                unauthorized access, alteration, disclosure, or destruction. We
                treat your personal stories, contact details, and volunteer data
                with the highest level of respect and security.
              </p>
            </section>

            <section data-id="element-723" data-mp="1xigp2u9g8ad6">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-724" data-mp="1xiqdideui9gr">
                5. Third-Party Services
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-725" data-mp="1ikxzxqsuzv57">
                We may use trusted third-party services (such as secure payment
                processors or email delivery systems) to help operate our
                ministry. These services only have access to the information
                necessary to perform their specific tasks and are obligated not
                to disclose or use it for any other purpose.
              </p>
            </section>

            <section data-id="element-726" data-mp="14szz039ax5k4">
              <h2 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-727" data-mp="14ukp9gol22c6">
                6. Contact Us
              </h2>
              <p className="leading-relaxed" data-id="element-728" data-mp="qw4lnym0ory9">
                If you have any questions about this Privacy Policy or how we
                handle your information, please contact us. We are always happy
                to provide clarity and ensure you feel secure in your
                interactions with 3 Doves Podcast.
              </p>
            </section>
          </div>
        </div>
      </div>
    </PageTransition>;
}